import { load } from '@redux/middleware/persist';
import { createSlice } from '@reduxjs/toolkit';
const persistedValue = load('quote.persisted', {
    id: '',
    quote: undefined,
});
export const initialState = {
    persisted: persistedValue,
};
const slice = createSlice({
    initialState,
    name: 'quote',
    reducers: {
        updateQuote: (state, action) => {
            state.persisted = { ...state.persisted, ...action.payload };
        },
    },
});
export const { updateQuote } = slice.actions;
export const name = slice.name;
export const reducer = slice.reducer;
